import { Navigate, Outlet, useLocation } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import SectionContainer from 'modules/core/components/SectionContainer'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useHasOnboardingEnabled } from 'modules/employee_onboarding/lib/utils'
import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'

import CollectionsBootstrap from 'modules/dashboard/lib/CollectionsBootstrap'

const Container = () => {
  const { pathname } = useLocation()
  const { navigation } = useNavigation()
  const { employee } = useCurrentSession()
  const onboardingEnabled = useHasOnboardingEnabled()

  const onboardingAccess = !hasRegularAccessOrNotEmployee(employee) && onboardingEnabled
  const isDashboardPath = pathname.includes(navigation.dashboard.path)

  if (isDashboardPath && onboardingAccess)
    return <Navigate to={navigation.employee_onboarding.fullPath()} replace />

  return (
    <AuthorizeUser authorizeFn={() => hasRegularAccessOrNotEmployee(employee)}>
      <SectionContainer>
        <Outlet />
      </SectionContainer>
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <SectionContainer>
        <Container />
      </SectionContainer>
    </CollectionsBootstrap>
  )
}

export default RootPage
